<template>
	<v-list-item
		v-if="userHasPermission"
		:href="href"
		:rel="href && href !== '#' ? 'noopener' : undefined"
		:target="href && href !== '#' ? '_blank' : undefined"
		:to="{ path: item.to, params: item.params }"
		:active-class="`primary white--text`"
		@click="clickHandler"
	>
		<v-list-item-icon v-if="item.icon">
			<v-icon v-text="item.icon" />
		</v-list-item-icon>

		<v-list-item-avatar
			v-else-if="item.avatar"
			class="align-self-center"
			color="grey"
		>
			<v-img src="" />
		</v-list-item-avatar>

		<v-list-item-content v-if="item.title || item.subtitle">
			<v-list-item-title v-text="item.title" />
			<v-list-item-subtitle v-text="item.subtitle" />
		</v-list-item-content>
	</v-list-item>
</template>

<script>
import Themeable from 'vuetify/lib/mixins/themeable';
import permissionsMixin from '@/mixins/permissionsMixin';

export default {
	name: 'Item',

	mixins: [Themeable, permissionsMixin],

	props: {
		item: {
			type: Object,
			default: () => ({
				href: undefined,
				icon: undefined,
				subtitle: undefined,
				title: undefined,
				to: undefined,
				clickHandler: undefined,
				permissionsNeeded: [],
			}),
		},
		text: {
			type: Boolean,
			default: false,
		},
	},

	computed: {
		userHasPermission() {
			if (!this.item.permissionsNeeded?.length) return true;

			return this.hasPermissions(this.item.permissionsNeeded);
		},
		computedText() {
			if (!this.item || !this.item.title) return '';

			let text = '';

			this.item.title.split(' ').forEach((val) => {
				text += val.substring(0, 1);
			});

			return text;
		},
		href() {
			return this.item.href || (!this.item.to ? '#' : undefined);
		},
		clickHandler() {
			return this.item.clickHandler || function () {};
		},
	},
};
</script>
